import { NumberType } from '../../api/models';

export let NumberTypeDisplay: { [index: number]: string } = {};
NumberTypeDisplay[NumberType.Private] = "enums.NumberType.Private";
NumberTypeDisplay[NumberType.PrivateWithKeyword] = "enums.NumberType.PrivateWithKeyword";
NumberTypeDisplay[NumberType.Public] = "enums.NumberType.Public";

